import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';

export type Rating = 'unlikely' | 'at_risk' | 'slightly_at_risk' | 'on_track' | 'likely';

const RATING_ORDER: Rating[] = ['unlikely', 'at_risk', 'slightly_at_risk', 'on_track', 'likely'];

type Props = {
	rating: Rating;
	compact?: boolean;
};

const classes = new BemClass('OrderForecastRatingScale');

const RatingScale = ({ rating, compact }: Props) => {
	const { t } = useTranslation();
	const currentIndex = RATING_ORDER.indexOf(rating);

	return (
		<div className={classes.mod({ compact }).b()}>
			{RATING_ORDER.map((r, i) => {
				const stepClass = classes
					.elem('step')
					.mod({
						current: i === currentIndex,
						passed: i < currentIndex
					})
					.b();
				return (
					<div key={r} className={stepClass} title={compact ? t(`ai.dealForecast.rating.${r}`) : undefined}>
						<span className={classes.elem('tick').b()} />
						{!compact && (
							<span className={classes.elem('label').b()}>{t(`ai.dealForecast.rating.short.${r}`)}</span>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default RatingScale;
